import { STEPS } from "@/data/site";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

export const HowItWorks = () => (
  <section id="process" data-testid="process-section" className="bg-espresso grain relative py-24 md:py-36">
    <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-10">
      <SectionHeading chapter="08" eyebrow="How It Works" title="Four Steps To" script="a flawless feast." dark />
      <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.12}>
            <div data-testid={`process-step-${s.n}`} className="relative pt-8 border-t border-gold/30 group hover:border-gold transition-colors duration-500">
              <span className="font-serif text-6xl md:text-7xl text-outline-cream group-hover:text-gold/20 transition-colors duration-500 select-none">{s.n}</span>
              <h3 className="mt-4 font-serif text-xl md:text-2xl text-cream">{s.title}</h3>
              <p className="mt-3 text-cream/55 text-sm font-light leading-relaxed">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
